/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.invoices.rpc.ApplyingCreditMemosToInvoicesService
 */

export const getInvoiceBalanceDueRpc = {
  serviceName: 'com.hubspot.invoices.rpc.ApplyingCreditMemosToInvoicesService',
  rpcName: 'getInvoiceBalanceDue',
  auth: 'app',
  fingerprint: '-8JAPVEkHOQHm4VYmJJVnJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCreditMemoApplicationResponseRpc = {
  serviceName: 'com.hubspot.invoices.rpc.ApplyingCreditMemosToInvoicesService',
  rpcName: 'getCreditMemoApplicationResponse',
  auth: 'app',
  fingerprint: '8FM7YvyNcZj4wBKucQQHoSs3czpS-I5q',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};